// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/news-share.css
// module id = 2676
// module chunks = 2